import React, { useEffect } from "react";

const TermsAndServices = () => {

   useEffect(() => {
     window.scrollTo(0, 0);
   }, []);

  return (
    <div className="terms-container p-6 bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200">
      <h1 className="text-2xl font-bold mb-4">Terms and Conditions</h1>
      <p>Welcome to Vinayaga Roofing Tiles!</p>
      <p>
        These Terms and Conditions ("Terms") govern the use of our website and
        the sale of tiles and jaali through our services. By browsing our
        website or contacting us via WhatsApp or phone, you agree to these
        Terms.
      </p>

      <h2 className="text-xl font-semibold mt-6">1. Products Offered</h2>
      <p>
        We provide a variety of roofing tiles and jaali in different designs and
        categories to meet your needs. For more information or to place an
        order, contact us directly.
      </p>

      <h2 className="text-xl font-semibold mt-6">2. Order Process</h2>
      <ul className="list-disc ml-6">
        <li>All orders must be placed via WhatsApp or phone.</li>
        <li>
          Product availability and pricing will be confirmed during the order
          discussion.
        </li>
        <li>
          Once the order details are finalized, customers will receive a
          confirmation message with the agreed terms.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6">3. Payment Terms</h2>
      <p>
        - Payments are handled offline and as per the agreement with the
        customer.
        <br />
        - Payment details will be shared directly during the order confirmation
        process.
        <br />- Customers are responsible for making timely payments as agreed.
      </p>

      <h2 className="text-xl font-semibold mt-6">4. Delivery and Pickup</h2>
      <ul className="list-disc ml-6">
        <li>
          Delivery charges, if applicable, will be communicated during the order
          discussion.
        </li>
        <li>
          Customers can also arrange to pick up their orders directly from our
          location.
        </li>
        <li>
          Delivery timelines will be provided based on product availability and
          location.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6">5. Returns and Refunds</h2>
      <p>
        - Returns are accepted only for damaged or defective products, reported
        within 24 hours of delivery.
        <br />
        - Refunds or replacements will be processed after verifying the issue.
        <br />- Products must be returned in their original condition for a
        refund or exchange.
      </p>

      <h2 className="text-xl font-semibold mt-6">6. Product Information</h2>
      <p>
        - We strive to ensure accurate product descriptions and images on our
        website.
        <br />- However, minor variations in color or design may occur due to
        lighting and manufacturing processes.
      </p>

      <h2 className="text-xl font-semibold mt-6">7. Customer Responsibility</h2>
      <p>
        - Customers must verify product details and ensure suitability before
        placing an order.
        <br />- We are not responsible for issues arising from incorrect product
        selection.
      </p>

      <h2 className="text-xl font-semibold mt-6">8. Privacy</h2>
      <p>
        - Any personal information provided will be used solely for order
        processing and communication.
        <br />- We do not share customer information with third parties.
      </p>

      <h2 className="text-xl font-semibold mt-6">9. Changes to Terms</h2>
      <p>
        - We reserve the right to update these Terms at any time. Updates will
        be reflected on this page, and customers are encouraged to review the
        Terms periodically.
      </p>

      <h2 className="text-xl font-semibold mt-6">10. Contact Us</h2>
      <p>
        If you have any questions or wish to place an order, please contact us:
        <br />
        - WhatsApp/Phone: (+91) 98659 80220
        <br />
        - Address: 177, Sathy Rd, Opp. Bus Stand, Erode, Tamil Nadu 638003
        <br />- Email:{" "}
        <a href="mailto:vinayagaroofingtiles@gmail.com">
          vinayagaroofingtiles@gmail.com
        </a>
      </p>
    </div>
  );
};

export default TermsAndServices;
